export const events = {
  edit: {
    profilePic: {
      start: 'START_EDITING_PROFILE_PICTURE',
      stop: 'STOP_EDITING_PROFILE_PICTURE',
      cancel: 'CANCEL_EDITING_PROFILE_PICTURE'
    },
    companyPic: {
      start: 'START_EDITING_COMPANY_PICTURE',
      stop: 'STOP_EDITING_COMPANY_PICTURE',
      cancel: 'CANCEL_EDITING_COMPANY_PICTURE'
    },
    start: 'START_EDITING_PICTURES',
    stop: 'STOP_EDITING_PICTURES'
  },
  set: {
    profilePic: 'SET_PROFILE_PICTURE',
    companyPic: 'SET_COMPANY_PICTURE'
  },
  upload: {
    profilePic: {
      uploading: 'UPLOADING_PROFILE_PICTURE',
      uploaded: 'UPLOADING_PROFILE_PICTURE_COMPLETE'
    },
    companyPic: {
      uploading: 'UPLOADING_COMPANY_PICTURE',
      uploaded: 'UPLOADING_COMPANY_PICTURE_COMPLETE'
    }
  }
}

const { upload, edit, set } = events

export const actions = {
  edit: {
    profilePic: {
      start: () => ({
        type: edit.profilePic.start
      }),
      stop: () => ({
        type: edit.profilePic.stop
      }),
      cancel: () => ({
        type: edit.profilePic.cancel
      })
    },
    companyPic: {
      start: () => ({
        type: edit.companyPic.start
      }),
      stop: () => ({
        type: edit.companyPic.stop
      }),
      cancel: () => ({
        type: edit.companyPic.cancel
      })
    },
    start: () => ({
      type: edit.start
    }),
    stop: () => ({
      type: edit.stop
    })
  },
  set: {
    profilePic: (image) => ({
      type: set.profilePic,
      image
    }),
    companyPic: (image) => ({
      type: set.companyPic,
      image
    })
  },
  upload: {
    profilePic: {
      uploading: () => ({
        type: upload.profilePic.uploading
      }),
      uploaded: () => ({
        type: upload.profilePic.uploaded
      })
    },
    companyPic: {
      uploading: () => ({
        type: upload.companyPic.uploading
      }),
      uploaded: () => ({
        type: upload.companyPic.uploaded
      })
    }
  }
}
